import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import * as deepIntegrationActions from 'hellospa/page/prep-and-send/data/actions/deep-integration';
import * as selectors from 'hellospa/page/prep-and-send/data/selectors';

/**
 * For deep-integration users, an external file should be auto converted (from their dbx folder)
 * whereas for HS, a user must manually upload a file. Therefore, kick off a file loader / polling
 * function.
 */
export function useConvertDeepIntegrationFile() {
  const dispatch = useDispatch();
  const isDeepIntegration = useSelector(selectors.isDeepIntegration);

  React.useEffect(() => {
    if (isDeepIntegration) {
      dispatch(deepIntegrationActions.convertDeepIntegrationFile());
    }
  }, [dispatch, isDeepIntegration]);
}
